var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e4e6ea;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5429",
    "data-name": "Rectangle 5429",
    className: "cls-1",
    width: 71,
    height: 71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "post_add-24px",
    transform: "translate(0.03 0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    className: "cls-2",
    width: 90,
    height: 90,
    transform: "translate(-0.03 -0.03)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8587",
    "data-name": "Group 8587",
    transform: "translate(10.97 7.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8586",
    "data-name": "Group 8586",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26437",
    "data-name": "Path 26437",
    className: "cls-1",
    d: "M63.313,0H7.874A7.845,7.845,0,0,0,.04,7.914L0,63.313a7.878,7.878,0,0,0,7.874,7.914H63.313a7.937,7.937,0,0,0,7.914-7.914V7.914A7.937,7.937,0,0,0,63.313,0m0,47.484H47.484a11.871,11.871,0,0,1-23.742,0H7.874V7.914H63.313Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPlaceholder);
export default __webpack_public_path__ + "static/media/pdf-placeholder.2fddbc183533f156fced2145b84e1843.svg";
export { ForwardRef as ReactComponent };